import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const Card = ({ data }) => {
  const label =
    data.type === 'Policy statement' ? 'Policy statement' : data.tag;

  return (
    <div className="statementcard">
      <div>
        <div className="statementimage">
          {data?.thumbnail ? (
            <img
              src={data?.thumbnail}
              alt={`${data.speaker}, ${data.speaker_title}, speaker from ${
                data.administration || data.organisation
              }, ${data.country}`}
            />
          ) : (
            <div className="fake-avatar">
              <FontAwesomeIcon icon={faUser} />
            </div>
          )}
        </div>
        <div className="statementcontent">
          <p className="statementtype">{label}</p>
          <p className="statementcountry">{data.country}</p>
          <p className="statementname">{data.speaker}</p>
          <p className="statementtitle">{data.speaker_title}</p>
          <p className="statementadminorg">
            {data.administration || data.organisation}
          </p>
        </div>
      </div>
      <div className="statementdate">
        <p>{data.assigned_slot}</p>
      </div>
    </div>
  );
};

const StatementCard = ({ data }) => {
  const currentlanguage = data.link.replace(
    '/en/',
    '/' + document.documentElement.lang + '/'
  );
  console.log();
  return (
    <>
      {data && data.status === 'publish' ? (
        <a href={currentlanguage} target="_blank" rel="noopener noreferrer">
          <Card data={data} />
        </a>
      ) : (
        <Card data={data} />
      )}
    </>
  );
};

export default StatementCard;
